import React, { useState, useEffect } from 'react';
import AdminTable from 'common/AdminTable';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import axios from 'axios';

const CityList = () => {
    const [cities, setCities] = useState([]);
    const token = localStorage.getItem('token'); // assuming token is stored here

    const fetchCities = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}city/admin`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCities(res.data);
        } catch (error) {
            console.error('Error fetching cities:', error);
            toast.error('Failed to fetch cities');
        }
    };

    useEffect(() => {
        fetchCities();
    }, []);

    const handleToggleStatus = async (city) => {
        const action = city.isOrderActive ? 'Disable' : 'Enable';
        Swal.fire({
            title: `Are you sure?`,
            text: `Do you want to ${action} orders for ${city.name}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, ${action} it!`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.patch(`${process.env.REACT_APP_BACKEND_URL}city/status/${city.id}`, {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    toast.success(`City ${action}d Successfully!`);
                    fetchCities();
                } catch (error) {
                    console.error('Error updating city status:', error);
                    toast.error('Failed to update city status');
                }
            }
        });
    };

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Name',
            accessor: 'name',
        },
        {
            Header: 'Country',
            accessor: 'country',
        },
        {
            Header: 'Status',
            accessor: 'isOrderActive',
            Cell: ({ row }) => (
                <span className={row.original.isOrderActive ? 'badge badge-success' : 'badge badge-danger'}>
                    {row.original.isOrderActive ? 'Active' : 'Inactive'}
                </span>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <button
                    className={`btn mx-1 my-1 ${row.original.isOrderActive ? 'btn-danger' : 'btn-success'}`}
                    onClick={() => handleToggleStatus(row.original)}
                >
                    {row.original.isOrderActive ? 'Disable' : 'Enable'}
                </button>
            ),
        },
    ];

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Manage Cities</h4>
            </div>
            {cities && cities.length > 0 ? (
                <AdminTable tableHeaders={tableHeaders} tableData={cities} />
            ) : (
                <div className="mx-4 mt-3">No cities found.</div>
            )}
        </div>
    );
}

export default CityList;
